import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";


@Component({
    selector: 'app-formSubmission-errors-dialog',
    templateUrl: './form-submission-error-dialog.html',
    styleUrls: ['./form-submission-error-dialog.scss']
})

export class FormSubmissionErrorsDialog {
    isLoaderEnabled: boolean = false;
    formErrorsArray: any = '';
    formConfig: any = {};

    constructor(public dialogRef: MatDialogRef<FormSubmissionErrorsDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {
        this.formErrorsArray = data.error;
        this.formConfig = data.orgform;
    }
    ngOnInit() {
    }
    onCancel(): void {
        // update reminder & Interviewer Info 
        this.dialogRef.close(null);
    }

    getDisplayName(data: string): string {
        switch (data) {
            case 'dialcode':
                return 'Code';
            case 'mobilenumber':
                return 'Mobile';
            case 'altmobilenumber':
                return this.formConfig['altmobinoFieldDisplayName'];
            case 'yearofpassing':
                return this.formConfig['yearOfPassingFieldDisplayName'];
            case 'organization':
                return 'Organization';
            case 'ctcvalue':
                return 'CTC';
            case 'skill':
                return 'Skills';
            case 'version':
                return 'Version';
            case 'degreename':
                return 'Degree Name';
            case 'university':
                return 'University';
            case 'ememobilenumber':
                return this.formConfig['emenumFieldDisplayName'];
            case 'name':
                return 'Name';
            case 'referencename':
                return 'Reference Name';
            case 'childrenname':
                return 'Children Name';
            case 'siblingname':
                return 'Sibling Name';
            case 'empid':
                return 'Emp ID';
            case 'location':
                return 'Location';
            case 'department':
                return 'Department';
            case 'identity':
                return 'Identity';
            case 'bank':
                return 'Financial Details';
            case 'designation':
                return 'Designation';
            case 'relationtype':
                return 'Relation Type';
            case 'email':
                return 'Email';
            case 'family':
                return 'Family Details';
            case 'startdt':
                return 'Start Date';
            case 'enddt':
                return 'End Date';
            case 'address':
                return 'Family Details';
            case 'age':
                return 'Age';
            case 'language':
                return 'Languages';
            case 'byteafiles':
                return 'Attach Resume';
            case 'medicalailmentsdetails':
                return 'Medical Ailments Details';
            default:
                // Fallback logic
                const key = data + 'FieldDisplayName';
                return this.formConfig[key] || data;
        }
    }

    getErrorMessage(data: { error: string; field: string }): string {
        switch (data.error) {
            case 'required':
                return data.field !== 'byteafiles' ? 'Required Field' : '';
            case 'max':
            case 'maxlength':
                return 'Maximum Length Exceeded';
            case 'min':
            case 'minlength':
                return 'Minimum Length Required';
            case 'pattern':
            case 'email':
                return 'Invalid Format';
            case 'matDatepickerMin':
                return 'Date is Invalid';
            case 'requiredOrEmptyHtml':
                return 'Required Field';
            case 'dateOutOfRange':
                return 'Out of Valid Date Range';
            default:
                if (data.field === 'byteafiles' && data.error === 'name') {
                    return 'File is Mandatory';
                }
                return '';
        }
    }


}